"use client";
import { Suspense, useEffect, useRef, useState } from "react";
import Lottie from "lottie-react";

const HeroLottie = () => {
  const [animationData, setAnimationData] = useState(null);
  const lottieRef = useRef(null);

  // Ease the playback speed down over the final stretch so the
  // single play settles smoothly instead of snapping to a stop.
  const handleEnterFrame = (e) => {
    const progress = e.currentTime / e.totalTime;
    if (progress > 0.7) {
      const t = (progress - 0.7) / 0.3; // 0 → 1 across the last 30%
      lottieRef.current?.setSpeed(Math.max(1 - t, 0.2));
    }
  };

  useEffect(() => {
    fetch("/assets/hero/heroGif.json")
      .then((res) => res.json())
      .then((data) => setAnimationData(data));
  }, []);
  if (!animationData) {
    return (
      <div className="w-full py-8 bg-white">
        <div className="flex h-full w-full">
          <div className="w-[22%] space-y-3 border-r border-gray-100 p-5">
            <div className="h-8 w-3/4 animate-pulse rounded bg-gray-200" />
            <div className="h-4" />
            {Array.from({ length: 8 }).map((_, i) => (
              <div
                key={i}
                className="h-6 w-full animate-pulse rounded bg-gray-100"
                style={{ animationDelay: `${i * 80}ms` }}
              />
            ))}
          </div>
          <div className="flex-1 space-y-4 p-5">
            <div className="flex gap-2">
              {Array.from({ length: 4 }).map((_, i) => (
                <div
                  key={i}
                  className="h-8 flex-1 animate-pulse rounded-full bg-gray-100"
                  style={{ animationDelay: `${i * 60}ms` }}
                />
              ))}
            </div>
            <div className="h-10 w-1/3 animate-pulse rounded bg-gray-200" />
            <div className="grid grid-cols-3 gap-3">
              {Array.from({ length: 3 }).map((_, i) => (
                <div
                  key={i}
                  className="h-24 animate-pulse rounded-lg bg-gray-100"
                  style={{ animationDelay: `${i * 100}ms` }}
                />
              ))}
            </div>
            <div className="space-y-2 pt-2">
              {Array.from({ length: 5 }).map((_, i) => (
                <div
                  key={i}
                  className="h-10 w-full animate-pulse rounded bg-gray-100"
                  style={{ animationDelay: `${i * 70}ms` }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Lottie
        lottieRef={lottieRef}
        animationData={animationData}
        loop={false}
        autoplay
        onEnterFrame={handleEnterFrame}
      />
    </Suspense>
  );
};

export default HeroLottie;
